import { Component, OnInit } from '@angular/core';
import { environment } from '@environments/environment';

@Component({
  selector: 'dc-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.less'],
})
export class NotFoundComponent implements OnInit {
  public href: string;

  ngOnInit() {
    switch (window.location.pathname) {
      case '/services/accounting':
        this.href = `${environment.showcaseUri}facturation-paramedicaux`;
        break;
      case '/services/waitlist':
        this.href = `${environment.showcaseUri}liste-attente-professionnels-sante`;
        break;
      case '/services/prl':
        this.href = `${environment.showcaseUri}prise-rendez-vous-en-ligne-paramédicaux`;
        break;
      case '/services/sms':
        this.href = `${environment.showcaseUri}rappels-sms-consultations`;
        break;
      case '/services/sharedfiles':
        this.href = `${environment.showcaseUri}messagerie-sécurisee-rgpd-sante`;
        break;
      case '/main':
        this.href = `${environment.showcaseUri}`;
        break;
      case '/security':
        this.href = `${environment.showcaseUri}conformite-rgpd-sante`;
        break;
      case '/founders':
        this.href = `${environment.showcaseUri}equipe`;
        break;
      case '/contact':
        this.href = `${environment.showcaseUri}contact`;
        break;
      case '/cgu/practitioner.html':
        this.href = `${environment.showcaseUri}conditions-generales-dutilisation`;
        break;
      case '/convention/pdp.html':
        this.href = `${environment.showcaseUri}charte-de-confidentialite`;
        break;
      case '/psychomotriciens':
        this.href = `${environment.showcaseUri}psychomotricien`;
        break;
      case '/cgu/patient.html':
        this.href = `${environment.prlUrl}cgu`;
        break;
      default:
        break;
    }
    if (!!this.href) {
      window.location.href = this.href;
    }
  }
}
